import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodNOOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order does not meet the 26 point threshold for ADC Truckload (i.e. direct shipment).</p>
                    <p><b>If this order qualifies for direct shipment based on the number of units, it can be reviewed and manually released by customer service.</b></p>
                    <p>Do you want to send this order for Customer Service review?</p>
                    <div className="noButtonContainer">
						<a onClick={(e) => this.props.handleCallBackAction('No', e)} href="" className="noButton blueButton">No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.handleCallBackAction('Yes', e)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog = connect(mapStateToProps)(ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog);
export default ChangeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodDoesNotMeetCriteriaForADCTruckloadOverlayDialog.js